import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, AlertController } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';

import { LanguageProvider } from '../../providers/language/language';
import { AuthProvider } from "../../providers/auth/auth";

import { Language } from '../../models/language.model';

import { BrandSelectorPage } from '../brand-selector/brand-selector';
import { ProductCategoriesPage } from '../product-categories/product-categories';
import { WelcomePage } from '../welcome/welcome';

import { RegisterPage } from './register';
import { ForgottenPasswordPage } from './forgotten-password';

@IonicPage()
@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {

  form: {
    username: string;
    password: string;
  };

  langs: Language[];

  currentLanguage: Language;

  constructor(private storage: Storage, public navCtrl: NavController, public navParams: NavParams, public translate: TranslateService, public loadingCtrl: LoadingController, public alertCtrl: AlertController, public languageProvider:LanguageProvider, public authProvider: AuthProvider) {
    this.form = {
      username: "",
      password: ""
    };

    this.currentLanguage = this.languageProvider.getByLocale(this.translate.currentLang);

    this.languageProvider.getLangs().subscribe(
      (langs: Language[]) => this.langs = langs
    );

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.currentLanguage = this.languageProvider.getByLocale(this.translate.currentLang);
    });

    // Remove token if we go this page
    this.authProvider.logout();
  }

  ionViewDidLoad() {
    if (this.navParams.get('disconnected') === true) {
      this.storage.set('basket', new Array());
      let alert = this.alertCtrl.create({
        title: this.translate.instant('MODAL_ERROR_TITLE'),
        subTitle: this.translate.instant('MODAL_ERROR_DISCONNECTED'),
        buttons: [
          this.translate.instant('BTN_OK')
        ]
      });
      alert.present();
    }
  }

  switchLang(lang: Language) {
    this.translate.use(lang.locale);
  }

  login() {
    let loading = this.loadingCtrl.create({
      content: this.translate.instant('MSG_PLEASE_WAIT')
    });

    loading.present();

    this.authProvider.login(this.form)
      .subscribe(
        res => {
          this.authProvider.profile().subscribe(
            user => {
              if (user.role_name != 'mwc') {
                this.storage.get('welcome').then((welcome) => {
                  this.navCtrl.setRoot((welcome) ? BrandSelectorPage : WelcomePage);
                });
              } else {
                this.navCtrl.setRoot(ProductCategoriesPage);
              }
            },
            error => {
              this.navCtrl.setRoot(BrandSelectorPage);
            }
          )
        },
        error => {
          loading.dismiss();
          if (error.status == 401) {
            let alert = this.alertCtrl.create({
              title: this.translate.instant('MODAL_ERROR_TITLE'),
              subTitle: this.translate.instant('MODAL_ERROR_LOGIN'),
              buttons: [
                this.translate.instant('BTN_OK')
              ]
            });
            alert.present();
          }
        },
        () => {
          loading.dismiss();
        }
      );
  }

  openForgottenPassword() {
    this.navCtrl.push(ForgottenPasswordPage);
  }

  openRegister() {
    this.navCtrl.push(RegisterPage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/auth/login.ts